import { createSlice } from '@reduxjs/toolkit'

export const vehicleSlice = createSlice({
    name: 'vehicles',
    initialState: {
        vehicles: [],
        vehicleList:[],
        activeVehicle: null,
        ledger:[],
        isLoading: false,
        reload: false
    },
    reducers: {
        getVehiclesFetch: (state) => {
            state.isLoading = true;
        },
        getVehiclesSuccess: (state, action) => {
            state.isLoading = false
            state.vehicles = action.payload
            state.vehicleList = action.payload.map(vehicle=>vehicle.name)
            state.reload = false
        },
        getVehiclesFail: (state) => {
            state.isLoading = false
        },
        setActiveVehicle:(state,action)=>{
            state.activeVehicle= action.payload
        }
        

    }
})
export const selectVehicles = (state) => state.vehicles.vehicles
export const selectVehicleList = (state) => state.vehicles.vehicleList
export const selectVehiclesIsLoading = (state) => state.vehicles.isLoading
export const selectActiveVehicle = (state) => state.vehicles.activeVehicle
export const { getVehiclesFetch, getVehiclesSuccess, getVehiclesFail,setActiveVehicle} = vehicleSlice.actions;
export default vehicleSlice.reducer